import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 10l9-9 9 9v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
      <path d="M9 22v-7h6v7" />
    </svg>
  ),
  map: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5 3.5l-5.5 2.2-6-2.4L3.5 5.5v15l5.5-2.2 6 2.4 5.5-2.2v-15z" />
      <path d="M9 4v13" />
      <path d="M15 6v12" />
    </svg>
  ),
  events: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  ),
  create: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v8M8 12h8" />
    </svg>
  ),
  challenges: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 3H5a2 2 0 00-2 2v4m0 0a6 6 0 0 0 12 0m0 0V5a2 2 0 00-2-2h-4m0 0V1m0 6h0m12 0v4a2 2 0 01-2 2h-4m0 0a6 6 0 01-12 0m0 0v4a2 2 0 002 2h4m0 0v2" />
    </svg>
  ),
};

export default function Sidebar() {
  const { currentUser } = useAuth();
  const location = useLocation();
  const displayName = currentUser && (currentUser.displayName || `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || currentUser.email || 'Utilisateur');
  const initials = displayName ? displayName.split(' ').map(n => n[0]).slice(0,2).join('').toUpperCase() : '?';
  const photoURL = currentUser && currentUser.photoURL;
  const [isPinned, setIsPinned] = useState(false);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  if (!currentUser) {
    return null;
  }

  const menuItems = [
    { label: 'Accueil', path: '/', icon: ICONS.home },
    { label: 'Carte', path: '/map', icon: ICONS.map },
    { label: 'Événements', path: '/events', icon: ICONS.events },
    { label: 'Challenges', path: '/challenges', icon: ICONS.challenges },
    { label: 'Créer', path: '/create-event', icon: ICONS.create, highlight: true },
  ];

  if (currentUser.isAdmin) {
    menuItems.push({ label: 'Défis admin', path: '/admin-challenges', icon: ICONS.challenges });
  }

  const expanded = true;

  return (
    <aside
      className="sidebar"
      data-expanded={true}
    >
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => setIsPinned(true)}
            className={`sidebar-item ${isActive(item.path) ? 'active' : ''} ${item.highlight ? 'highlight' : ''}`}
            title={item.label}
          >
            <div className="sidebar-icon-wrapper">
              {item.icon}
            </div>
            <span className="sidebar-label">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="sidebar-footer" style={{marginTop: 'auto'}}>
        <Link to="/profile" className="sidebar-user-link" title="Voir le profil" onClick={() => setIsPinned(true)}>
          <div className="avatar sidebar-avatar">
            {photoURL ? (
              <img src={photoURL} alt={displayName || 'Avatar'} />
            ) : (
              <div className="avatar-initials">{initials}</div>
            )}
          </div>
          <div className="sidebar-user-name">{displayName}</div>
        </Link>
      </div>
    </aside>
  );
}
